import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { attributeTypes, FindLoad } from 'utils';
import { Loader } from 'components';
import { formActions } from 'store';
import { FormBuilder } from '../../forms';

const ACTION_TYPE = 'GET_CLIENT_FILED_FORM';
const SAVE_ACTION_TYPE = 'CLIENT_FORM_REVIEW';
export const ClientConfirmForm = ({ client, afterSuccess }) => {
    const clientFiledForm = useSelector((state) => state.forms.clientFiledForm);
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        if (client) {
            dispatch(formActions.getClientFiledForm(client?.id));
        }
    }, [client]);

    const handleSaveAction = (data) => {
        const status = data?.sections[0].attributes[0];

        const sendData = {
            ...data,
        };

        if (status?.type === attributeTypes.SELECT && status?.name === 'clientStatus') {
            sendData?.sections[0]?.attributes.shift();
        }

        dispatch(formActions.clientFormReview(client?.id, sendData, status?.value?.id));
    };

    return (
        <div style={{ width: 650 }}>
            {loader?.length ? (
                <Loader />
            ) : (
                <div>
                    <div style={{ borderBottom: '1px solid #EBF2FD', paddingBottom: '16px', marginBottom: '16px' }}>
                        <p className="modal-header-title">Intake Form</p>
                        <p className="modal-header-sub">Review and update client information before saving to the profile</p>
                    </div>
                    <FormBuilder
                        width={'100%'}
                        defaultForm={clientFiledForm}
                        afterSuccess={() => afterSuccess()}
                        actionName={'Save to Client Profile'}
                        ACTION_TYPE={SAVE_ACTION_TYPE}
                        handleSaveNote={handleSaveAction}
                    />
                </div>
            )}
        </div>
    );
};
